import { CanActivateFn } from '@angular/router';
import { StoreService } from '../services/store.service';
import { inject } from '@angular/core';

export const isLoggedGuard: CanActivateFn = (route, state) => {
  const storeService = inject(StoreService);
  return storeService.isLogged;
};
